import { axiosInstanceV2 } from "../axios";

export function listMyVouchers(logged) {
    if (!logged) return []
    return axiosInstanceV2.get("/vouchers/my-vouchers").then(({ data }) => data)
}